import { Component, OnInit, ViewEncapsulation } from '@angular/core';

@Component({
    selector: 'app-no-permissions',
    templateUrl: './no-permissions.component.html',
    styleUrls: ['./no-permissions.component.scss'],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class NoPermissionsComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
